import Lottie from 'lottie-react';
import OpenSessionLottie from '../jsons/open-session.json';

const OpenSession = props => {
  return <Lottie loop={false} animationData={OpenSessionLottie} {...props} />;
};

export default OpenSession;
